export const Empty = 0;

export type DotValue = 1 |  2 |  3 |  4 |  5 |  6 |  7;
export type Solid =    8 |  9 | 10 | 11 | 12 | 13 | 14;
export type Cracked = 15 | 16 | 17 | 18 | 19 | 20 | 21;

// 0-21
export type CellValue =
  | typeof Empty
  | DotValue
  | Solid
  | Cracked;

// 1-14
export type DropValue = DotValue | Solid;

export type BoardOf<T> = [
  T, T, T, T, T, T, T,
  T, T, T, T, T, T, T,
  T, T, T, T, T, T, T,
  T, T, T, T, T, T, T,
  T, T, T, T, T, T, T,
  T, T, T, T, T, T, T,
  T, T, T, T, T, T, T,
];

export type ColumnOf<T> = [
  T,
  T,
  T,
  T,
  T,
  T,
  T,
];

export type ColumnsOf<T> = ColumnOf<ColumnOf<T>>;

export enum GameMode {
  Classic,
  Blitz,
  Sequence,
  Tutorial,
}

export type SavableGameMode = Exclude<GameMode, GameMode.Tutorial>;

export enum Bonus {
  None,
  LevelUp,
  BoardClear,
}

// state of the game at the current tick, not necessarily all serializable
export interface GameState {
  score: number;
  level: number;
  dropsTotal: number;
  dropsRemaining: number;
  currentDrop: DropValue;
  gameOver: boolean;
  combo: number;
  bonus: Bonus;
  columns: ColumnsOf<CellValue>;
  highlights: ColumnsOf<boolean>;
  cellScores: ColumnsOf<number>;
}

type ModeScoreData = {
  best: number;
  average: number;
  count: number;
};

export type ScoreData = Record<SavableGameMode, ModeScoreData>;
